export default __webpack_public_path__ + "static/casting-526bd659d9809ca91a7c03cf7037465c.png";